<template>
  <StepContainer
    v-loading="isLoading"
    :title="$t('APPS.DRAFT.STEPS.IN_APP_PURCHASE')"
    class="in-app-purchases-step"
  >
    <InAppPurchaseKeys
      :package-name="draftApp.packageName"
      class="in-app-purchases-step__keys"
    />
    <InAppPurchaseProducts :package-name="draftApp.packageName" />
    <StepControllers slot="actions" @change-step="goToStep" />
  </StepContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { CHANGE_DRAFT_APP_STATE, DRAFT_APP } from '@/store/types';
import InAppPurchaseKeys from './InAppPurchaseKeys';
import InAppPurchaseProducts from './InAppPurchaseProducts';
import StepContainer from '../common/StepContainer';
import StepControllers from '../common/StepControllers';

export default {
  name: 'InAppPurchasesStep',

  components: {
    StepContainer,
    StepControllers,
    InAppPurchaseKeys,
    InAppPurchaseProducts,
  },

  inject: ['stepperController'],
  data() {
    return {
      isLoading: false,
      fieldErrors: {},
    };
  },
  computed: {
    ...mapGetters({ draftApp: DRAFT_APP }),
  },
  watch: {
    draftApp: {
      immediate: true,
      handler() {},
    },
  },
  created() {
    this.stepperController.onStepClick(this.goToStep);
  },
  beforeDestroy() {
    this.stepperController.removeOnStepClick(this.goToStep);
  },
  methods: {
    ...mapActions({ checkAndChangeStep: CHANGE_DRAFT_APP_STATE }),

    goToStep(step) {
      this.isLoading = true;
      this.fieldErrors = {};

      this.checkAndChangeStep({ to: step, data: {} })
        .catch(({ message, errors = [], fieldErrors = {} }) => {
          this.$message.error(message);
          this.errors = errors;
          this.fieldErrors = fieldErrors;
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<style lang="scss">
.in-app-purchases-step {
  &__keys {
    margin-bottom: $global-margin * 2;
  }
}
</style>
